import {useContext, useState} from "react";
import {RuoliContext} from "../../../../context/RuoliContext";
import ContenutoModelliArchivioView from "./ContenutoMarcheArchivioView";
import {useHistory} from "react-router-dom";
import {FiltersContext} from "../../../../context/FiltersContext";
import {BreadcrumbsContext} from "../../../../context/BreadcrumbsContext";

export default function ContenutoModelliArchivioController({
                                                              marche,
                                                              handlerRefreshMarche,
                                                               tipoVeicolo,
                                                          }) {

    const [showModalAddMarca, setShowModalAddMarca] = useState(false);

    const {updateFiltroArchivio} = useContext(FiltersContext);
    const {addElementoBreadcrumbs} = useContext(BreadcrumbsContext);

    const history = useHistory();

    const {
        isRuoloSocio,
        isRuoloClub,
        isRuoloAgenzia,
    } = useContext(RuoliContext);

    const selectMarca = (marca) => {
        addElementoBreadcrumbs('marca', marca.marca, `/archivio-marca/${marca.id_archivio_marca}`);
        updateFiltroArchivio('id_archivio_marca', marca.id_archivio_marca);
        history.push(`/archivio-marca/${marca.id_archivio_marca}`);
    }

    return (
        <ContenutoModelliArchivioView
            marche={marche}
            isRuoloAd={!isRuoloSocio() && !isRuoloClub() && !isRuoloAgenzia()}
            openModalAddMarca={() => {
                setShowModalAddMarca(true);
            }}
            closeModalAddMarca={() => {
                setShowModalAddMarca(false);
            }}
            addMarcaOk={(marca) => {
                setShowModalAddMarca(false);
                handlerRefreshMarche();
            }}
            showModalAddMarca={showModalAddMarca}
            selectMarca={selectMarca}
            tipoVeicolo={tipoVeicolo}
        />
    );
}